/* eslint-disable no-underscore-dangle */

import Renderer from './device-license-status-renderer';

const DefaultColumnComponent = require('@gluenetworks/steve_ui_widgets').GridGl
  .DefaultColumnComponent;

const _ = require('lodash');

class DeviceLicenseStatusColumnComponent extends DefaultColumnComponent {
  constructor(value) {
    super(value);

    this._value = value;

    this._renderer = new Renderer(this);

    this._registerListeners();
  }

  /** **************************************** */
  /* START PRIVATE COMPONENT MODEL METHODS */
  /** **************************************** */
  _registerListeners() {}

  _unregisterListeners() {}

  /** **************************************** */
  /* END PRIVATE COMPONENT MODEL METHODS */
  /* START PUBLIC COMPONENT MODEL METHODS */
  /** **************************************** */
  get renderer() {
    return this.getRenderer();
  }

  getRenderer() {
    return this._renderer;
  }

  shutdown() {
    this._unregisterListeners();
    const prom = this._renderer._shutdown();
    this._renderer = undefined;
    return prom;
  }
  /** **************************************** */
  /* END COMPONENT MODEL METHODS */
  /* START HANDLER METHODS */
  /** **************************************** */

  /** **************************************** */
  /* END HANDLER METHODS */
  /* START PRIVATE METHODS */
  /** **************************************** */

  /** **************************************** */
  /* END PRIVATE METHODS */
  /* START PUBLIC API METHODS */
  /** **************************************** */
  setValue(newVal) {
    if (!_.isUndefined(newVal)) {
      this.setLicenseStatus(newVal);
    }
  }

  getValue() {
    return this.getLicenseStatus();
  }

  setLicenseStatus(newVal) {
    this._value = newVal;
    this.emit('LicenseStatus', newVal);
    return this;
  }

  getLicenseStatus() {
    return this._value;
  }

  /** **************************************** */
  /* END PUBLIC API METHODS */
  /** **************************************** */
}
export default DeviceLicenseStatusColumnComponent;
